import { Injectable } from "@angular/core";
import { ApiService } from "../../../services/api/api.service";
import { Observable } from "rxjs";
import { CreatePayLinkDto, DeletePaylinkDto, FormDataDto, FormSelectModelDto, PayLinksListDto, PayLinksModelDto } from "../models/paylinks.model";
import { UserInfoService } from "../../../services/user-info.service";
import { SortTableService } from "../../../services/sort-table.service";
import { FilterSearchResultDto } from "src/app/models/filter.model";

@Injectable({
  providedIn: "root",
})
export class PaymentLinksDataService {
  agentId: string | undefined;
  userId: number | undefined;

  sort: string | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res;
      },
    });
  }

  loadPaymentLinksList(page: number, search: string | undefined = "", data?: any): Observable<PayLinksListDto> {
    const url = `/agents/${this.agentId}/paylink/filter?page_number=${page}&size=20&${this.sort}&search=${search}`;
    return this.apiService.httpPost<PayLinksListDto>(url, data);
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/paylink/filter/list?page_number=0&per_page=10`;
    return this.apiService.httpPost<FilterSearchResultDto>(url, data);
  }

  loadPaymentLinksListFilter(): Observable<any> {
    const url = `/agents/${this.agentId}/paylink/filter`;
    return this.apiService.httpGet<any>(url);
  }

  loadPaymentFormData(): Observable<FormDataDto> {
    const url = `/agents/${this.agentId}/paylink/form-data`;
    return this.apiService.httpGet<FormDataDto>(url);
  }

  loadPaymentTypeData(pageNumber: number) {
    const url = `/agents/${this.agentId}/payment_types?page=${pageNumber}&size=20`;
    return this.apiService.httpGet<any>(url);
  }

  createPayLink(payLinkData: CreatePayLinkDto): Observable<void> {
    const url = `/agents/${this.agentId}/paylink`;
    return this.apiService.httpPost<void>(url, payLinkData);
  }

  deletePaylink(paylinkList: DeletePaylinkDto): Observable<void> {
    const url = `/agents/${this.agentId}/paylinks/delete`;
    return this.apiService.httpPost<void>(url, paylinkList);
  }

  loadDetailPaylink(token: string): Observable<PayLinksModelDto> {
    const url = `/agents/${this.agentId}/paylink/${token}`;
    return this.apiService.httpGet<PayLinksModelDto>(url);
  }

  editPaylink(payLinkData: CreatePayLinkDto, token: string): Observable<PayLinksModelDto> {
    const url = `/agents/${this.agentId}/paylink/${token}`;
    return this.apiService.httpPut<PayLinksModelDto>(url, payLinkData);
  }

  sendPaylinkMail(token: string, mail: string): Observable<void> {
    const url = `/agents/${this.agentId}/paylink/${token}/email/send?emails=${mail}`;
    return this.apiService.httpGet<void>(url);
  }

  copyPaylink(token: string, type: string): Observable<string> {
    const url = `/agents/${this.agentId}/paylink/${token}/copy?type=${type}`;
    return this.apiService.httpGet<string>(url);
  }

  changeStatus(token: string, state: boolean): Observable<void> {
    const url = `/agents/${this.agentId}/paylink/${token}?is_blocked=${state}`;
    return this.apiService.httpPatch<void>(url);
  }

  loadFile(): Observable<Blob> {
    const url = `/agents/${this.agentId}/reports/paylinks/download`;
    return this.apiService.httpGetBlob(url);
  }

  loadCurrencyList() {
    const url = `/reference/currency/list`;
    return this.apiService.httpGet<FormSelectModelDto[]>(url);
  }
}
